import { gql } from '@apollo/client'

import { VEHICLE_COMPONENT } from 'features/VehicleTemplates/components/Components/constants'

export const resolvers = {
  Mutation: {
    updateSeatStatus(_root: TSFixMe, { seatId, status }: TSFixMe, { cache }: TSFixMe) {
      cache.writeFragment({
        id: cache.identify({
          __typename: 'Seat',
          id: seatId
        }),
        fragment: gql`
          fragment SeatStatus on Seat {
            status
          }
        `,
        data: {
          status,
          __typename: 'Seat'
        }
      })

      return null
    }
  },
  VehicleTemplateCell: {
    isEmpty(cell: TSFixMe) {
      return cell.component === VEHICLE_COMPONENT.EMPTY
    }
  }
}
